import { render, staticRenderFns } from "./Tasks_editor.vue?vue&type=template&id=4a0531dc&scoped=true"
import script from "./Tasks_editor.vue?vue&type=script&lang=js"
export * from "./Tasks_editor.vue?vue&type=script&lang=js"
import style0 from "./Tasks_editor.vue?vue&type=style&index=0&id=4a0531dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0531dc",
  null
  
)

export default component.exports